import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class TesztlapokEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.vonalkodlatticesXMLVizsga = null;
		this.elokeszitettPath = null;
	}

	setup(props) {
		super.setup(props);
		this.latticesXML = props.latticesXML;
		this.elokeszitettPath = props.elokeszitettPath;
		return this;
	}
}

export default TesztlapokEditDto;
